var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('header',{staticClass:"main__header"},[_c('Header')],1),_c('main',{staticClass:"main__body"},[_c('MainNavigationMenu'),_c('div',{staticClass:"main__content"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }